export default "__VITE_ASSET__CCbHCI1___"